/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useState} from 'react';
import {xml2js} from 'xml-js';

import FilePickerDialog from 'components/forms/FilePickerDialog';
import {Button} from '@mui/material';
import ImportSubEventBody from './ImportSubEventBody';

export type ControlType = {
  name: string;
  type: string;
  position: {
    lat: number;
    lng: number;
  };
  id: number;
  siCode: number;
};

export type SubEventType = {
  name: string;
  controls: ControlType[];
};

const ImportSubEventsButton = () => {
  const [subEvents, setSubEvents] = useState<SubEventType[]>([]);
  const [allControls, setAllControls] = useState<ControlType[]>([]);

  const handleFileChange = (xmlString: string) => {
    const data: any = xml2js(xmlString, {compact: true});
    if (data.CourseData && data.CourseData.RaceCourseData && data.CourseData.RaceCourseData) {
      const allControls: ControlType[] = data.CourseData.RaceCourseData.Control.map((control: any) => {
        const position = control.Position._attributes;
        return {
          name: control.Id._text,
          type: 'default',
          position: {
            lat: parseFloat(position.lat),
            lng: parseFloat(position.lng)
          },
          id: parseInt(control.Id._text) || 0,
          siCode: parseInt(control.Id._text) || 0
        };
      });
      setAllControls(allControls);
      const subEventsObj = data.CourseData.RaceCourseData.Course.map((course: any) => {
        const controls =
          course.CourseControl?.map((control: any) => {
            const id = control.Control._text;
            return allControls.find((c) => c.name === id);
          }) || [];
        return {
          name: course.Name._text,
          controls
        };
      });
      setSubEvents(subEventsObj);
    }
  };

  return (
    <React.Fragment>
      <FilePickerDialog
        label="IOF XML v3"
        variant="text"
        accept=".xml"
        extension="xml"
        handleFileChange={handleFileChange}
        fullWidth={false}
        primaryButton={
          <Button type="submit" form="import_sub_events" variant="contained">
            Create
          </Button>
        }
      >
        <ImportSubEventBody controls={allControls} subEvents={subEvents} />
      </FilePickerDialog>
    </React.Fragment>
  );
};

export default ImportSubEventsButton;
